import React, { useState, useEffect } from "react"
import "./Clock.css" // Importing the CSS for the animations

const Clock = () => {
  const [time, setTime] = useState(new Date())

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date())
    }, 1000)

    // Clean up the timer on component unmount
    return () => clearInterval(timer)
  }, [])

  // Get hours, minutes, and seconds
  const hours = time.getHours()
  const minutes = time.getMinutes()
  const seconds = time.getSeconds()

  // Calculating the degree for each hand of the clock
  const hourDegree = (hours % 12) * 30 + minutes * 0.5
  const minuteDegree = minutes * 6
  const secondDegree = seconds * 6
  const formatTime = date => {
    const hrs = date.getHours()
    const mins = date.getMinutes()
    const secs = date.getSeconds()
    const period = hrs >= 12 ? "PM" : "AM"

    const formattedHours = hrs % 12 || 12
    const formattedMinutes = mins < 10 ? `0${mins}` : mins
    const formattedSeconds = secs < 10 ? `0${secs}` : secs

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds} ${period}`
  }

  return (
    <div className="digital-clock">
      <p style={{ color: "black" }}>{formatTime(time)}</p>
    </div>
  )
}

export default Clock
